import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAuthSession } from '../utils/api';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    clearAuthSession(navigate);
  }, [navigate]);

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <div className="text-center">
        <div className="spinner-border text-danger mb-3" role="status">
          <span className="visually-hidden">Logging out...</span>
        </div>
        <p className="text-muted mb-0">Signing you out...</p>
      </div>
    </div>
  );
};

export default Logout;
